import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export default function ImgMediaCard({ heading, body, cardImage }) {
  return (
    <Card
      sx={{
        width: "100%",
        background:
          "linear-gradient(145deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.7) 100%)",
        backdropFilter: "blur(20px)",
        borderRadius: "24px",
        border: "1px solid rgba(255, 255, 255, 0.3)",
        overflow: "visible",
        position: "relative",
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-8px)",
          "& .card-image": {
            transform: "scale(1.05)",
          },
        },
      }}
    >
      <CardContent sx={{ p: 3, height: "100%", display: "flex", flexDirection: "column" }}>
        <MDBox
          sx={{
            width: "80px",
            height: "80px",
            position: "absolute",
            top: "-20px",
            left: "20px",
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(26, 233, 98, 0.1)",
              zIndex: 1,
            },
          }}
        >
          <CardMedia
            component="img"
            image={cardImage}
            alt={heading}
            className="card-image"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "right",
              transition: "transform 0.3s ease",
            }}
          />
        </MDBox>

        <MDBox pl={12} pt={1}>
          <MDTypography
            variant="h3"
            sx={{
              fontSize: "1.4rem",
              fontWeight: 700,
              color: "#1A202C",
              mb: 1,
              mt: -1,
              letterSpacing: "-0.02em",
            }}
          >
            {heading}
          </MDTypography>
          <MDTypography
            variant="body2"
            sx={{
              fontSize: "1rem",
              color: "#4A5568",
              lineHeight: 1.6,
            }}
          >
            {body}
          </MDTypography>
        </MDBox>
      </CardContent>
    </Card>
  );
}
ImgMediaCard.propTypes = {
  heading: PropTypes.string,
  body: PropTypes.string,
  cardImage: PropTypes.string,
};
